var t = require('i18n').t

module.exports = require('./abstract-annual-report').extend({
    model: function() {
        var model = this.modelFor('annual_report')
        var annualReportService = this.get('annualReport')

        return Object.assign({
            items: annualReportService.getTangibleFixedAssets(model.commitment),
            missingAccounts: annualReportService.getMissingAccounts(model.commitment, 'tangible_fixed_assets')
        }, model)
    },

    afterModel: function(model) {
        /*
        @TODO AR-2 disable fields instead of reloading
        var commitment = model.commitment
        if (['completed', 'delivered', 'received', 'reported'].indexOf(commitment.state) > -1) {
            this.replaceWith('annual_report.report_completed')
        }
        */

        return model.items.map(function(item) {
            item.title = t('annual_report.' + item.key + '.title')

            if (item.key !== 'tangible_fixed_assets.refurbishment_of_rented_premises') {
                item.label = t('annual_report.' + item.key + '.label')
            }
        })
    },

    setupController: function(controller, model) {
        controller.set('model', model)
        controller.set('items', model.items)
        controller.set('steps', model.steps)
        controller.set('commitment', model.commitment)
        controller.set('currentStep', model.currentStep)
        controller.set('fixedAssets', model.commitment.fixedAssetsMovements.tangible)
        controller.set('missingAccounts', model.missingAccounts)
    }
})
